export default defineNuxtRouteMiddleware((to, from) => {
  const url = useRequestURL()

  if (url.href.includes('www.')) {
    return navigateTo(url.href.replace('www.', ''), { external: true })
  }
  if (to.path.includes('/tech')) {
    return navigateTo('https://help.smsbat.com/api', {
      redirectCode: 301,
      external: true
    })
  }
  if (to.path === '/prices' || to.path === '/prices/') {
    return navigateTo('/pricing', {
      redirectCode: 301
    })
  }
  if (to.path === '/sign-up' || to.path === '/sign-up/') {
    return navigateTo('https://omni.smsbat.com/register', {
      redirectCode: 301,
      external: true
    })
  }

  // Add trailing slash redirect for consistency (except root and paths with file extensions)
  if (to.path !== '/' && !to.path.endsWith('/') && !to.path.includes('.')) {
    const query = to.fullPath.includes('?') ? to.fullPath.substring(to.fullPath.indexOf('?')) : ''
    const hash = to.hash || ''
    return navigateTo(to.path + '/' + query + hash, {
      redirectCode: 301,
      external: false
    })
  }
})